import React from 'react';
import { motion } from 'framer-motion';
import { Container } from '../ui/Container';
import { AlertTriangle, TrendingUp, FileWarning } from 'lucide-react';
export function RealityCheck() {
  const stats = [{
    value: '60-70%',
    label: 'of project time spent on admin',
    description: 'Engineers are expensive data entry clerks.',
    icon: TrendingUp
  }, {
    value: '80%',
    label: 'of projects go over budget',
    description: 'Due to poor visibility and delayed reporting.',
    icon: AlertTriangle
  }, {
    value: 'Disconnected',
    label: 'systems create silos',
    description: 'Data lives in spreadsheets, email, and isolated apps.',
    icon: FileWarning
  }];
  return <section className="bg-dashboard-surface py-16 md:py-24 border-b border-dashboard-border" data-id="element-225">
      <Container data-id="element-226">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-227">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-228">
            <h2 className="text-4xl font-black tracking-tight text-dashboard-text sm:text-5xl mb-6" data-id="element-229">
              The Reality of{' '}
              <span className="text-tech-blue" data-id="element-230">Project Delivery</span>
            </h2>
            <div className="space-y-4 text-dashboard-text leading-relaxed" data-id="element-231">
              <p data-id="element-232">
                Your best people are drowning in paperwork. They didn't study
                engineering to update spreadsheets, chase approvals, or manually
                copy data from one system to another.
              </p>
              <p data-id="element-233">
                When systems don't talk to each other, mistakes happen.
                Variations get missed. Handover packs are delayed. And profit
                margins erode.
              </p>
            </div>
          </motion.div>

          <div className="grid grid-cols-1 gap-6" data-id="element-234">
            {stats.map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-dashboard-bg rounded-lg p-6 border border-dashboard-border" data-id="element-235">
                <div className="flex items-start gap-4" data-id="element-236">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-tech-red/10 border border-tech-red/20 flex items-center justify-center" data-id="element-237">
                    <stat.icon className="w-6 h-6 text-tech-red" data-id="element-238" />
                  </div>
                  <div className="flex-1" data-id="element-239">
                    <div className="text-3xl font-black text-tech-red mb-2" data-id="element-240">
                      {stat.value}
                    </div>
                    <div className="font-bold text-dashboard-text mb-1" data-id="element-241">
                      {stat.label}
                    </div>
                    <div className="text-sm text-dashboard-muted" data-id="element-242">
                      {stat.description}
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </Container>
    </section>;
}